import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Grid, SemanticICONS } from 'semantic-ui-react'
import { DashboardSegment } from './DashboardSegment'

interface DashboardNumberSegmentProps {
  link: string
  title: string
  icon: SemanticICONS
  value: number
}

export const DashboardNumberSegment: React.FC<DashboardNumberSegmentProps> = ({ link, title, icon, ...props }) => {
  return (
    <Container as={Link} to={link}>
      <DashboardSegment
        title={title}
        icon={icon}
        value={
          <Grid.Column className='segment-number' style={{ display: 'flex', justifyContent: 'center', fontSize: '20px' }}>
            <div>{props.value}</div>
          </Grid.Column>
        }
      />
    </Container>
  )
}
